import * as React from 'react';
import styled from 'styled-components';
import { TweenMax } from 'gsap';
import { Cookies, withCookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

// Components
import TextBlock from '../TextBlock';

// Assets
import { brandColors, fonts } from '../../styles/variables';

const Wrapper = styled.div`
  background-color: rgba(155, 162, 174, 0.6);
  width: 100%;
  z-index: 99999;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
`;

const Content = styled.div`
  background-color: ${brandColors.orange};
  padding: 17px;
  max-width: 800px;
  box-sizing: border-box;
  width: 95%;
  position: absolute;
  top: 50%;
  left: 50%;
  cursor: default;
  transform: translate(-50%, -50%);

  .text-block {
    max-width: 100%;
    display: inline-block;
    vertical-align: bottom;
    color: ${brandColors.blue};

    p {
      font-size: 20px;
      line-height: 31px;
      margin: 25px 0;
      text-align: center;

      a {
        color: ${brandColors.yellow};
      }
    }
  }
`;

const AcknowledgementBtn = styled.div`
  position: absolute;
  top: 21px;
  right: 10px;
  cursor: pointer;

  &:after {
    content: '\00d7';
    display: block;
    text-align: center;
    font-size: 3rem;
    line-height: 0;
    font-family: ${fonts.monterrat};
    color: ${brandColors.blue};
  }
`;

class SystemMessage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.banner = React.createRef();
    this.showBanner = false;
    this.cookieName = 'RD_Website_SystemMessageBannerDismiss';
  }

  componentWillMount() {
    // need to check if we need to still show the banner
    const { cookies } = this.props;

    if (cookies.get(this.cookieName)) {
      this.showBanner = false;
    }
  }

  closeBanner() {
    const { cookies } = this.props;
    TweenMax.to(this.banner.current, 0.3, { opacity: 0 });
    TweenMax.set(this.banner.current, { delay: 0.3, display: 'none' });

    const newdate = new Date();
    newdate.setDate(newdate.getDate() + 1);

    cookies.set(this.cookieName, 1, { path: '/', expires: newdate });
  }

  render() {
    if (this.showBanner) {
      return (
        <Wrapper innerRef={this.banner} onClick={() => this.closeBanner()}>
          <Content onClick={event => event.stopPropagation()}>
            <TextBlock className="text-block">
              <p>
                As per the government’s COVID-19 recommendations we have facilitated home working
                for our team and our office is closed. If you need to speak to a member of the team
                and you do not have their mobile phone number, please email{' '}
                <a href="mailTo:info@radical-departures.com">info@radical-departures.com</a> and
                someone will get back to you as soon as possible.
              </p>
            </TextBlock>

            <AcknowledgementBtn onClick={() => this.closeBanner()} />
          </Content>
        </Wrapper>
      );
    }

    return false;
  }
}

SystemMessage.propTypes = {
  cookies: instanceOf(Cookies).isRequired
};

export default withCookies(SystemMessage);



// WEBPACK FOOTER //
// ./src/components/SystemMessage/index.jsx